import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import './styles/global.css';

import Home from './pages/Home';
import ActorPage from './pages/Actor/ActorPage';
import DeveloperPage from './pages/Developer/DeveloperPage';
import AdminPage from './pages/Admin/AdminPage';

// VideoEditor, Coach and Bartender pages exist in /pages/ but are
// not routed yet — they will be re-added when fully built out.

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/actor" element={<ActorPage />} />
          <Route path="/developer" element={<DeveloperPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}
